import React from 'react';
import { useLoader } from 'react-three-fiber'
import { GLTFLoader, GLTF } from 'three/examples/jsm/loaders/GLTFLoader'
import Field from '../Field';

type GLTFResult = GLTF & {
  nodes: any,
  materials: any,
}
function BataviaField(props:any ) {
  const model = useLoader<GLTFResult>(GLTFLoader, '/assets/Batavia/Batavia.gltf');

  return (
    <Field
      name="Batavia"  
      modelGeometry={model.nodes.Batavia.geometry}
      modelMaterial={model.materials.Batavia_glTF}
      // modelScale={2}
      modelYPosition={-0.5}
      {...props}
    />
  );
}

export default BataviaField;

